import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contract-merge',
  templateUrl: './contract-merge.component.html'
})
export class ContractMergeComponent implements OnInit {

  mergeContractsForm: FormGroup;

  constructor() {
    this.mergeContractsForm = new FormGroup({
      name: new FormControl('', [Validators.required])
    });
  }

  ngOnInit() {
  }

  mergeContracts () {
    //alert("MERGE");
  }
}



// WEBPACK FOOTER //
// ./src/app/contract/contract-merge.component.ts